<template>
  <div class="general-card">
    <div class="container-form-profil">
      <div id="form-profil-15">

        <div class="form-group form-radio-image form-logement clear-after">

          <fieldset>

            <div
              class="form-ssgroup profil-logement-oui">
              <label
                for="form-profil-logement-oui"
                @click.prevent="change('y')">
                <input
                  type="radio"
                  id="form-profil-logement-oui"
                  name="logement"
                  value="y"
                  :checked="has_home === 'y'">J'ai un logement <br>à partager
                <span class="checkmark"></span>
              </label>
            </div>
            <div
              class="form-ssgroup profil-logement-non">
              <label
                for="form-profil-logement-non"
                @click.prevent="change('n')">
                <input
                  type="radio"
                  id="form-profil-logement-non"
                  name="logement"
                  value="n"
                  :checked="has_home === 'n'"
                  :omg="has_home === 'n'">
                <span class="checkmark"></span>
                Je n'ai pas de logement <br>à partager
              </label>
            </div>

          </fieldset>
          <div class="texterror" v-if="!$v.has_home.required && errorcheck" style="text-align: center; margin-top: 20px">Champ obligatoire.</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'home-1',
  props: ['user', 'fields', 'disabledNoDefault'],
  data: () => ({
    errorcheck: false,
    has_home: '',
    can_change_error: Promise.resolve(false),
  }),
  created() {
    this.$emit('progress', 75)

    // If edition
    if (this.user.home && this.user.home.step >= 3) {
      this.can_change_error = this.$http.get('/api/users/error-if-running-subscription').then(
        () => false,
        err => err,
      )
    }

    // Unselect has_home if next step is not completed
    if (this.disabledNoDefault) {
      this.has_home = this.user.home ? 'y' : 'n'
    } else {
      this.has_home = this.user.home ? 'y' : ''
    }
  },
  validations: {
    has_home: {
      required: v => v !== '',
    },
  },
  methods: {
    change(value) {
      if (this.has_home === value) return

      this.can_change_error.then(err => {
        if (err) this.$error(err)
        else {
          this.has_home = value
          this.$emit('change', value === 'y')
        }
      })
    },
    previousPage() {
      return 'ignore'
    },
    nextPage(scroll = true) {
      this.errorcheck = false
      if (this.$v.$invalid) {
        this.errorcheck = true
        return false
      }

      // Create a home if he hasn't already one
      if (this.has_home === 'y' && !this.user.home) {
        return this.$http.post('/api/homes', {}).then(res => {
          this.$set(this.user, 'home', res.data)
          return 'ignore'
        })
      } else if (this.has_home === 'n' && this.user.home) {
        return this.$http.delete(`/api/homes/${this.user.home.id}`).then(res => {
          this.$set(this.user, 'home', null)
          return 'ignore'
        })
      } else {
        return 'ignore'
      }
    },
  },
}
</script>
